import { useVirtualizer } from '@tanstack/react-virtual';
import { FreeformMessage } from '../../generated/graphql';
import { useVirtualMessageThreadContainerContext } from '../context';

interface VirtualMessageThreadItemContainerProps {
  children: (p: { message?: FreeformMessage; dateDivider?: Date }) => React.ReactNode;
  measureElement: ReturnType<typeof useVirtualizer>['measureElement'];
}

export function VirtualMessageThreadItemContainer({
  children,
  measureElement,
}: VirtualMessageThreadItemContainerProps) {
  const { virtualItem, virtualizerItems } = useVirtualMessageThreadContainerContext();
  const item = virtualizerItems[virtualItem.index];

  return (
    <div data-index={virtualItem.index} ref={measureElement}>
      {children({
        message: item.type === 'FreeformMessage' ? item.item : undefined,
        dateDivider: item.type === 'DateDivider' ? item.item : undefined,
      })}
    </div>
  );
}
